import {useState} from 'react'
import useApi from '../../../services/useApi'

export default function useScriptOperations() {
  const [isLoading, setLoading] = useState(false)
  const Api = useApi()

  const createScript = (data: any, setError: any) => {
    return Api.post('/storefronts/script/manager/scripts', data, {
      setLoading,
      successMessage: 'Script created successfully',
      refetch: 'storefront-scripts-list',
      setUseFormError: setError,
    })
  }

  const updateScript = (data: any, scriptId: string, setError: any) => {
    return Api.put(`/storefronts/script/manager/scripts/${scriptId}`, data, {
      setLoading,
      successMessage: 'Script updated successfully',
      refetch: 'storefront-scripts-list',
      setUseFormError: setError,
    })
  }


  return {
    createScript,
    updateScript,
    isOperationLoading: isLoading,
  }
}
